// extracted by mini-css-extract-plugin
export default {"modal":"OrderPadModal-module__modal___uWOXP"};